import React, { PureComponent } from 'react'
import { Field, FieldArray, reduxForm } from 'redux-form'
import { TextField, SelectField } from 'redux-form-material-ui'
import { required, money } from '../form/validation'
import FlatButton from 'material-ui/FlatButton'
import MenuItem from 'material-ui/MenuItem'
import Send from 'material-ui/svg-icons/content/send'
import MultiImages from './MultiImages'
import { themeColors } from '../styles/theme'

const styles = {
  imagesContainer: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  footerStyle: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 8,
    height: 50,
    backgroundColor: themeColors.footergrey,
    zIndex: 1000,
  },
  scrolling: {
    overflow: 'scroll',
    paddingBottom: 60,
  },
}

class OwnedForm extends PureComponent {
  render() {
    const {
      item,
      handleSubmit,
      submitting,
      conditions = [],
      toggleOpen,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div style={styles.scrolling}>
          <h3>{item.titolo}</h3>
          <div>
            <Field
              name="condizioni"
              disabled={submitting}
              component={SelectField}
              style={{ width: '100%' }}
              hintText={
                item.categoria.id === 50 ? 'Condizioni Disco' : 'Condizioni'
              }
              floatingLabelText={
                item.categoria.id === 50 ? 'Condizioni Disco' : 'Condizioni'
              }
              validate={required}>
              {conditions.map(({ value, label }) => (
                <MenuItem
                  value={value}
                  primaryText={label}
                  key={value}
                  style={{ zIndex: 222 }}
                />
              ))}
            </Field>
          </div>

          {item.categoria.id === 50 &&
            <div>
              <Field
                name="condizioni2"
                disabled={submitting}
                component={SelectField}
                style={{ width: '100%' }}
                hintText="Condizioni Copertina"
                floatingLabelText="Condizioni Copertina"
                validate={required}>
                {conditions.map(({ value, label }) => (
                  <MenuItem
                    value={value}
                    primaryText={label}
                    key={value}
                    style={{ zIndex: 222 }}
                  />
                ))}
              </Field>
            </div>}

          <div>
            <Field
              name="valore"
              disabled={submitting}
              component={TextField}
              style={{ width: '100%' }}
              hintText="Valore*"
              floatingLabelText="Valore*"
              validate={[required, money]}
              min={0}
            />
          </div>
          <div>
            <p style={{ marginTop: 0 }}>
              <small>
                * inserisci un valore comprensivo di spese di spedizione oppure indica gli eventuali costi di spedizione a carico dell’acquirente nelle note
              </small>
            </p>
          </div>

          <div style={styles.imagesContainer}>
            <FieldArray name="altre_immagini" component={MultiImages} />
          </div>

          <div>
            <Field
              name="descrizione"
              component={TextField}
              disabled={submitting}
              hintText="Note"
              floatingLabelText="Note"
              multiLine={true}
              fullWidth={true}
              rows={2}
            />
          </div>
        </div>

        <div>
          <FlatButton
            type="submit"
            disabled={submitting}
            label="OK"
            primary={true}
            icon={<Send />}
            style={{ float: 'right', marginRight: 10 }}
          />
          <FlatButton
            type="button"
            label="Annulla"
            secondary={true}
            onClick={toggleOpen}
            style={{ float: 'left', marginLeft: 10 }}
          />
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'owned-form',
})(OwnedForm)



// WEBPACK FOOTER //
// ./src/common/OwnedForm.js